import { PartialType } from '@nestjs/swagger';
import { CreateProductoImagenDto } from './create-producto-imagen.dto';

export class UpdateProductoImagenDto extends PartialType(CreateProductoImagenDto) {}
